/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const Checkmark400Icon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Checkmark400',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
    width="${width}"
    height="${height}"
  >
    <path
      d="M5.864 14.114a1.13 1.13 0 0 1-.868-.407L1.25 9.21a1.13 1.13 0 1 1 1.736-1.448l2.854 3.425 7.148-9.1a1.13 1.13 0 1 1 1.778 1.397L6.753 13.682a1.13 1.13 0 0 1-.872.432z"
    />
  </svg>`;
};
